import { derived } from 'svelte/store'
import { kategorier } from './kategorier'
import { currentRoute } from './router'

export const title = derived([currentRoute, kategorier], ([$currentRoute, $kategorier]) => {
  const parts = ['NRK Lyspunkt']
  if ($currentRoute.name === 'kategori') {
    const kategori = $kategorier.find((k) => k.slug === $currentRoute.params.slug)
    parts.push(kategori?.kortnavn)
  }
  return [...parts, 'Spesial'].filter(Boolean).join(' - ')
})
